const navData = [
  {
    name: "About",
    link: "#about",
  },
  {
    name: "Projects",
    link: "#work",
  },
  {
    name: "Contact",
    link: "#contact",
  },
];

export default navData;
